export default "__VITE_ASSET__oCBc6VI2__"